
import {
  BUTTON_SIZES,
  BUTTON_SIZE_XSMALL,
  BUTTON_SIZE_SMALL,
  BUTTON_SIZE_MEDIUM,
  BUTTON_SIZE_LARGE,
  BUTTON_VARIANTS,
  BUTTON_VARIANT_DEFAULT,
  BUTTON_VARIANT_DEFAULT_RED,
  BUTTON_VARIANT_RED,
  BUTTON_VARIANT_GREEN,
  BUTTON_VARIANT_BLUE,
  BUTTON_VARIANT_LIGHT_BLUE,
  BUTTON_VARIANT_LINK,
  BUTTON_VARIANT_LINK_RED,
  BUTTON_VARIANT_LINK_DARK,
  BUTTON_VARIANT_PLAIN,
  BUTTON_VARIANT_PLAIN_WHITE,
} from '../../utils/constants'

export default {
  props: {
    size: {
      type: String,
      default: BUTTON_SIZE_MEDIUM,
      validator: (value) => {
        return Object.keys(BUTTON_SIZES).includes(value)
      },
    },
    variant: {
      type: String,
      default: BUTTON_VARIANT_DEFAULT,
      validator: (value) => {
        return Object.keys(BUTTON_VARIANTS).includes(value)
      },
    },
    href: {
      type: String,
      required: false,
      default: null,
    },
    to: {
      type: [String, Object],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.href) {
        return 'a'
      }

      if (this.to) {
        return 'nuxt-link'
      }

      return 'button'
    },
    bound() {
      switch (this.tag) {
        case 'a':
          return { href: this.href }
        case 'nuxt-link':
          return { to: this.to }
        case 'button':
        default:
          return { disabled: this.disabled }
      }
    },
    buttonClass() {
      const base = [
        'tw-inline-flex',
        'tw-cursor-pointer',
        'tw-items-center',
        'tw-justify-center',
        'tw-gap-2',
        'tw-rounded-md',
        'tw-border-0',
        'tw-font-medium',
      ]

      return [...base, ...this.variantClass, ...this.sizeClass]
    },
    sizeClass() {
      let cls = {}
      switch (this.size) {
        case BUTTON_SIZE_XSMALL:
          cls = { padding: 'tw-px-2 tw-py-2', text: 'tw-text-xs' }
          break
        case BUTTON_SIZE_SMALL:
          cls = { padding: 'tw-px-3 tw-py-2', text: 'tw-text-sm' }
          break
        default:
        case BUTTON_SIZE_MEDIUM:
          cls = { padding: 'tw-px-6 tw-py-3', text: 'tw-text-base' }
          break
        case BUTTON_SIZE_LARGE:
          cls = { padding: 'tw-px-8 tw-py-3.5', text: 'tw-text-lg' }
      }
      if (this.dense) {
        cls.padding = 'tw-p-0'
      }
      return Object.values(cls)
    },
    variantClass() {
      const cls = []

      if (this.disabled) {
        cls.push('!tw-cursor-not-allowed tw-opacity-[0.43]')
      }

      switch (this.variant) {
        case BUTTON_VARIANT_DEFAULT:
          cls.push(
            'tw-bg-white tw-text-gray-800 hover:tw-bg-gray-50 hover:tw-no-underline active:tw-bg-gray-100 tw-ring-inset tw-ring-1 tw-ring-gray-200',
          )
          break
        case BUTTON_VARIANT_DEFAULT_RED:
          cls.push(
            'tw-bg-white tw-text-red-500 hover:tw-bg-gray-50 hover:tw-no-underline active:tw-bg-gray-100 tw-ring-inset tw-ring-1 tw-ring-gray-200',
          )
          break
        case BUTTON_VARIANT_RED:
          cls.push(
            'tw-bg-red tw-antialiased tw-text-white hover:tw-bg-red-500 hover:tw-no-underline hover:tw-text-white active:tw-bg-red-600 tw-ring-inset tw-ring-1 tw-ring-black/10',
          )
          break
        case BUTTON_VARIANT_LIGHT_BLUE:
          cls.push(
            'tw-bg-blue-100 tw-antialiased tw-text-blue-600 hover:tw-bg-blue-200 hover:tw-no-underline hover:tw-text-blue-700 active:tw-bg-blue-200 tw-ring-inset tw-ring-1 tw-ring-blue-100/10',
          )
          break
        case BUTTON_VARIANT_BLUE:
          cls.push(
            'tw-bg-blue tw-antialiased tw-text-white hover:tw-bg-blue-700 hover:tw-no-underline hover:tw-text-white active:tw-bg-blue-800 tw-ring-inset tw-ring-1 tw-ring-black/10',
          )
          break
        case BUTTON_VARIANT_GREEN:
          cls.push(
            'tw-bg-green tw-antialiased tw-text-white hover:tw-bg-green-700 hover:tw-text-white hover:tw-no-underline active:tw-bg-green-800 tw-ring-inset tw-ring-1 tw-ring-black/10',
          )
          break
        case BUTTON_VARIANT_PLAIN:
          cls.push(
            'tw-bg-transparent tw-text-gray-800 hover:tw-bg-gray-800/3 hover:tw-no-underline active:tw-bg-gray-800/6',
          )
          break
        case BUTTON_VARIANT_PLAIN_WHITE:
          cls.push(
            'tw-bg-transparent tw-text-white hover:tw-bg-gray-50/5 hover:tw-no-underline active:tw-bg-gray-50/10',
          )
          break

        case BUTTON_VARIANT_LINK:
          cls.push('tw-text-link hover:tw-text-link-hover tw-underline')
          break
        case BUTTON_VARIANT_LINK_RED:
          cls.push('tw-text-red-500 hover:tw-text-red-600 tw-underline')
          break
        case BUTTON_VARIANT_LINK_DARK:
          cls.push('tw-text-gray-700 hover:tw-text-gray-900 tw-underline')
          break
      }
      return cls
    },
  },
}
